import api from "./api";

/**
 * @file report.js
 * @description Servicio de reportes del paciente ("Reportar un problema").
 *   Reusa el tipo de tarea `reports` (ReportTask) del API: el paciente crea su
 *   propio reporte y el médico lo ve en su bandeja. Sin cambio de backend.
 */
const reportService = {};

/**
 * @description Lista los reportes creados por el paciente logueado.
 * @returns {Promise<Array<Object>>}
 */
reportService.getMyReports = function () {
  return api
    .get("/tasks/reports/type/patient", { params: { limit: 100 } })
    .then((res) => (res.data && res.data.docs) || [])
    .catch(() => []);
};

/**
 * @description Plantillas de reporte que dejó configuradas el médico (tipos de
 *              problema). Sirven para prellenar el reporte del paciente. Puede
 *              venir vacío (la org no configuró ninguna) — el paciente igual
 *              puede reportar "Otro".
 * @returns {Promise<Array<Object>>}
 */
reportService.getTemplates = function () {
  return api
    .get("/tasks/reports/type/treatment", { params: { limit: 100 } })
    .then((res) => (res.data && res.data.docs) || [])
    .catch(() => []);
};

/**
 * @description Crea un reporte del paciente. Requiere episodio activo (lo
 *              resuelve el backend). `treatmentTask` es el id de la plantilla
 *              elegida (opcional).
 * @param {Object} args
 * @param {string} args.name - Título / tipo del problema
 * @param {string} args.observation - Descripción de lo que pasó
 * @param {string} [args.treatmentTask] - _id de la plantilla (si eligió una)
 * @returns {Promise<Object>} el reporte creado
 */
reportService.create = function ({ name, observation, treatmentTask }) {
  const body = { name, observation };
  if (treatmentTask) body.treatmentTask = treatmentTask;
  return api.post("/tasks/reports/type/patient", body).then((res) => res.data);
};

/**
 * @description Adjunta un archivo (foto) a un reporte ya creado.
 * @param {string} reportId - _id del reporte
 * @param {File} file - archivo a subir
 * @returns {Promise<Object>}
 */
reportService.uploadFile = function (reportId, file) {
  const fd = new FormData();
  fd.append("files", file);
  return api
    .put(`/tasks/reports/type/patient/${reportId}/files`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);
};

export default reportService;
